// import {BehaviorSubject} from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var StoreService = (function () {
    function StoreService() {
        // 依赖更新部分
        this.store = {
            loadingComponent: {
                loading: false
            }
        };
        //通知机制部分
        this.notification = {
            notAuthed: new BehaviorSubject(null),
            isChannel: new BehaviorSubject(null),
            askImmediately: new BehaviorSubject(null),
            refreshHomePage: new BehaviorSubject(null),
            mentorEntered: new BehaviorSubject(null),
        };
    }
    StoreService.prototype.commit = function (nameSpace, data) {
        this.store[nameSpace] = Object.assign(this.store[nameSpace] || {}, data);
    };
    StoreService.prototype.getter = function (nameSpace, key) {
        return this.store[nameSpace][key];
    };
    return StoreService;
}());
export { StoreService };



// WEBPACK FOOTER //
// ./src/app/store.service.ts.pre-build-optimizer.js